let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1oWbP")).then(() => parcelRequire('iPUaD'));